import { render, staticRenderFns } from "./addBaseAcos.vue?vue&type=template&id=b326c142&scoped=true"
import script from "./addBaseAcos.vue?vue&type=script&lang=js"
export * from "./addBaseAcos.vue?vue&type=script&lang=js"
import style0 from "./addBaseAcos.vue?vue&type=style&index=0&id=b326c142&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b326c142",
  null
  
)

export default component.exports